/**
 * 다음(카카오) 우편번호 위젯. npm 의존 없이 스크립트 태그로 지연 로드한다.
 * `window.daum.Postcode`가 이미 있으면 재사용하고, 중복 주입을 막는다.
 * 주문서(위저드)와 상세 인라인 수정(바텀시트)이 함께 쓴다.
 */

export interface DaumPostcodeData {
  roadAddress: string
  jibunAddress: string
  zonecode: string
}
interface DaumPostcodeInstance {
  open: () => void
}
declare global {
  interface Window {
    daum?: {
      Postcode: new (opts: { oncomplete: (data: DaumPostcodeData) => void }) => DaumPostcodeInstance
    }
  }
}

const DAUM_POSTCODE_SRC = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'
let daumLoader: Promise<void> | null = null

export function loadDaumPostcode(): Promise<void> {
  if (window.daum?.Postcode) return Promise.resolve()
  if (daumLoader) return daumLoader
  daumLoader = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = DAUM_POSTCODE_SRC
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      daumLoader = null // 실패는 캐시하지 않는다(다음 시도 재로드).
      reject(new Error('주소 검색 스크립트를 불러오지 못했습니다'))
    }
    document.head.appendChild(script)
  })
  return daumLoader
}

/** 주소 검색 창을 열어 완료 시 도로명(없으면 지번) 주소·우편번호를 콜백으로 넘긴다. */
export async function openPostcodeSearch(
  onComplete: (data: { address: string; zipcode: string }) => void,
): Promise<void> {
  await loadDaumPostcode()
  const Postcode = window.daum?.Postcode
  if (!Postcode) throw new Error('주소 검색을 사용할 수 없습니다')
  new Postcode({
    oncomplete: (data) => onComplete({ address: data.roadAddress || data.jibunAddress, zipcode: data.zonecode }),
  }).open()
}
